import { render, staticRenderFns } from "./moderator-selector.vue?vue&type=template&id=119652b0"
import script from "./moderator-selector.vue?vue&type=script&lang=ts"
export * from "./moderator-selector.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports